export { default } from './ReferralMedication';
